/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Properties_SubtitleInputs */

const cs_properties_subtitle = /** @type {(inputs: Properties_SubtitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Registrace a správa nabídek.`)
};

const en_properties_subtitle = /** @type {(inputs: Properties_SubtitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Listing registry and offer management.`)
};

/**
* | output |
* | --- |
* | "Listing registry and offer management." |
*
* @param {Properties_SubtitleInputs} inputs
* @param {{ locale?: "cs" | "en" }} options
* @returns {LocalizedString}
*/
export const properties_subtitle = /** @type {((inputs?: Properties_SubtitleInputs, options?: { locale?: "cs" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Properties_SubtitleInputs, { locale?: "cs" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_properties_subtitle(inputs)
	return cs_properties_subtitle(inputs)
});